import React from "react";
import { useTranslation } from "react-i18next";

import { getShortUserName } from "~/libs/getData";
import { getFormatDate } from "~/libs/getFormatDate";
import {
  DataRow,
  DataRows,
} from "~/pages/BaseStaff/EmployeeProfileViewing/EmployeeProfileView/components/DataRows";
import { formatDisplayValue } from "~/pages/BaseStaff/EmployeeProfileViewing/EmployeeProfileView/model/display";
import {
  TEmployeePosition,
  TEmployeePositionDealerWithMeta,
} from "~/pages/BaseStaff/EmployeeProfileViewing/EmployeeProfileView/model/types";

import s from "~/pages/BaseStaff/EmployeeProfileViewing/EmployeeProfileView/EmployeeProfileView.less";

interface IPositionHistorySectionProps {
  positions: TEmployeePosition[];
}

type THistoryItem = {
  key: string;
  positionName: string;
  dealer: TEmployeePositionDealerWithMeta;
};

const PositionHistorySection = ({
  positions,
}: IPositionHistorySectionProps) => {
  const { t } = useTranslation();

  const items: THistoryItem[] = [];
  positions.forEach((position, positionIndex) => {
    (position.InactivePositions || []).forEach((inactive, inactiveIndex) => {
      if (!inactive) {
        return;
      }

      const positionName = inactive.Position?.name || "";
      (inactive.Positions || []).forEach((dealer, dealerIndex) => {
        if (!dealer) {
          return;
        }

        items.push({
          key: `${positionIndex}-${inactiveIndex}-${dealerIndex}`,
          positionName,
          dealer,
        });
      });
    });
  });

  return (
    <section className={s.sectionCompact}>
      <h2 className={s.sectionTitle}>{t("employee.jobHistory")}</h2>

      {!items.length && (
        <p className={s.historyEmpty}>{t("employee.positionHistoryEmpty")}</p>
      )}

      {items.map(({ key, positionName, dealer }) => {
        const author = dealer.fireByUser || dealer.lastStatusUpdateByUser;

        return (
          <div className={s.historyBlock} key={key}>
            {positionName && <h4 className={s.historyTitle}>{positionName}</h4>}
            <DataRows>
              <DataRow label={`${t("employee.organization")}:`}>
                {formatDisplayValue(dealer.Dealer?.DealerName)}
              </DataRow>
              <DataRow label={`${t("employee.HiredDate")}:`}>
                {dealer.startDate
                  ? getFormatDate(dealer.startDate, true)
                  : formatDisplayValue(null)}
              </DataRow>
              <DataRow label={`${t("employee.firedFromWork")}:`}>
                {dealer.endDate
                  ? getFormatDate(dealer.endDate, true)
                  : formatDisplayValue(null)}
              </DataRow>
              <DataRow label={`${t("employee.changeAuthor")}:`}>
                {author?.fullname
                  ? getShortUserName(author.fullname)
                  : formatDisplayValue(null)}
              </DataRow>
            </DataRows>
          </div>
        );
      })}
    </section>
  );
};

export default PositionHistorySection;
